import { useEffect, useState } from "react";
import { nowTime } from "lib/utils/now";

export function useNowTime(intervalMs = 5 * 60 * 1000) {
  const [time, setTime] = useState(() => nowTime());

  useEffect(() => {
    const t = setInterval(() => {
      setTime(nowTime());
    }, intervalMs);

    return () => clearInterval(t);
  }, [intervalMs]);

  return time;
}
